
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'INRCurrency'
})
export class INRCurrencyPipe implements PipeTransform {
    transform(value): string {

        if (!value) {
            return '-'
        }
        console.log("kjasdhjkagsdkuaysdkjadgs", String(value));
        if (String(value).includes('.')) {
            var onlyNumbers = String(value).replace(/\D/g, "");
            // console.log("kjasdhjkagsdkuaysdkjadgs", onlyNumbers);
            var onlyNumbers1 = Math.floor(Number(onlyNumbers) / 100)
            console.log("kjasdhjkagsdkuaysdkjadgs23232323", onlyNumbers, String(onlyNumbers1));
        } else {
            var onlyNumbers1 = Number(String(value).replace(/\D/g, ""));
            console.log("kjasdhjkagsdkuaysdkjadgs12121", String(onlyNumbers1));
        }

        value = Math.round(Number(onlyNumbers1));
        var result = value.toString().split('.');
        var lastThree = result[0].substring(result[0].length - 3);
        var otherNumbers = result[0].substring(0, result[0].length - 3);
        if (otherNumbers != '' && otherNumbers != '-')
            lastThree = ',' + lastThree;
        var output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

        if (result.length > 1) {
            output += "." + result[1];
        }

        return "₹" + output + ".00";

    }
}